/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { GridCellBase } from "./GridCellBase";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TextCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TextCell, _super);
    function TextCell(a) {
        var _this = _super.call(this, a) || this;
        _this.b3 = null;
        _this.b6 = -1;
        _this.b5 = -1;
        _this.b3 = a.createElement("span");
        _this.z.setRawStyleProperty("text-align", "left");
        _this.b3.setRawStyleProperty("display", "inline-block");
        _this.b3.setRawStyleProperty("line-height", "normal");
        _this.b3.setRawStyleProperty("vertical-align", "middle");
        _this.b3.setRawStyleProperty("overflow", "hidden");
        _this.b3.setRawStyleProperty("white-space", "nowrap");
        _this.b3.setRawStyleProperty("text-overflow", "ellipsis");
        _this.z.setRawStyleProperty("vertical-align", "middle");
        _this.z.append(_this.b3);
        return _this;
    }
    Object.defineProperty(TextCell.prototype, "b4", {
        get: function () {
            return this.b3;
        },
        enumerable: true,
        configurable: true
    });
    TextCell.prototype.bs = function (a, b) {
        _super.prototype.bs.call(this, a, b);
        var c = Math.max(0, a - b - (this.au + this.aw + this.av));
        if (this.b6 != c) {
            this.b6 = c;
            this.b3.setRawStyleProperty("max-width", c.toString() + "px");
        }
    };
    TextCell.prototype.bm = function (a, b) {
        _super.prototype.bm.call(this, a, b);
        var c = Math.max(0, a - b);
        if (this.b5 != c) {
            this.b5 = c;
            this.b3.setRawStyleProperty("max-height", c.toString() + "px");
        }
    };
    TextCell.prototype.get_r = function () {
        return true;
    };
    TextCell.prototype.bd = function (a, b, c) {
        _super.prototype.bd.call(this, a, b, c);
        if (a == "Indent" || a == "IsCollapsable") {
            this.b3.setRawStyleProperty("margin-left", this.au + this.aw + this.av + "px");
        }
    };
    TextCell.$t = markType(TextCell, 'TextCell', GridCellBase.$);
    return TextCell;
}(GridCellBase));
export { TextCell };
//# sourceMappingURL=TextCell.js.map
